import { sortBy } from 'lodash';

const REPLIERS_IMAGE_NUMBER_REGEX = /_(\d+)./;

export default function orderRepliersImages(
  images: Array<string>,
): Array<string> {
  return sortBy(images, image => {
    const match = image.match(REPLIERS_IMAGE_NUMBER_REGEX);
    if (match) {
      return Number(match[1]);
    } else {
      return 0;
    }
  });
}
